import actionCreatorFactory from "typescript-fsa";
import {LoginResponse, SNSDataList} from "../util/api";

const actionCreator = actionCreatorFactory();

export const hogeActions = {
    updateName: actionCreator<string>("ACTIONS_UPDATE_NAME"),
    updateEmail: actionCreator<string>("ACTIONS_UPDATE_EMAIL"),
};

export const SetAuthTokenAction = actionCreator<string>("CHANGE_AUTH_TOKEN");
export const SetUidAction = actionCreator<string>("CHANGE_UID");
export const SetUserInfo = actionCreator<LoginResponse>("CHANGE_USER_INFO");

export const SetSNSLists = actionCreator<SNSDataList[]>("CHANGE_SNSLIST");
export const AddSNSLists = actionCreator<SNSDataList>("ADD_SNSLIST");
export const ClearSNSLists = actionCreator<void>("CLEAR_SNSLIST");
export const DeleteSNSList = actionCreator<number>("DELETE_SNSLIST");

export const DemoSetSNSLists = actionCreator<SNSDataList[]>(
    "DEMO_CHANGE_SNSLIST"
);
export const DemoAddSNSLists = actionCreator<SNSDataList>("DEMO_ADD_SNSLIST");
export const DemoClearSNSLists = actionCreator<void>("DEMO_CLEAR_SNSLIST");
export const DemoDeleteSNSList = actionCreator<number>("DEMO_DELETE_SNSLIST");

export const UpdateSuccessSnackBar = actionCreator<string>(
    "SHOW_SUCCESS_SNACKBAR"
);
export const UpdateErrorSnackBar = actionCreator<string>("SHOW_ERROR_SNACKBAR");
export const HideSnackbar = actionCreator("HIDE_SNACKBAR");
